import React from 'react';
import ReserveForm from '../components/ReserveForm';

const Reserve = () => (
  <>
    <ReserveForm />
  </>
);

export default Reserve;
